export class ProjectClass {
  constructor(work_order_grp_id?: string, description?: string) {
    this.work_order_grp_id = work_order_grp_id;
    this.description = description;
  }

  work_order_grp_id: string;
  description: string;
}
